type WSEvent = any;

export const processIncoming = (ev: WSEvent) => {
    console.log("websockets event ", ev);
}
